// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container__ZE__s","title":"index_title__sO7TN","desc":"index_desc__diQ1s","tags":"index_tags__GlvsI","active":"index_active__9vdln"};